/**
 * Generated by orval v8.21.0 🍺
 * Do not edit manually.
 * Kreditportal Backend API
 * Das Kreditportal ermöglicht Versicherungsnehmern die Kautionsverträge einzusehen, anzupassen und Bürgschaften zu beantragen. Diese API ist eine Middleware fürs Frontend zu den Backend-Systemen.
 * OpenAPI spec version: 4.0.6-FINAL
 */
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse as AngularHttpResponse } from '@angular/common/http';

import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    Buergschein,
    BuergscheinListe,
    BuergscheinNummernResponse,
    GetBuergscheinDokumentParams,
    GetBuergscheineParams
} from '../kreditportalBackendAPI.schemas';


interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (
      preserveRequiredNullables &&
      value === null &&
      requiredNullableKeys.has(key)
    ) {
      filteredParams[key] = null;
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class BuergscheineApiService {
  private readonly http = inject(HttpClient);
/**
 * Dieser Service ermöglicht es, den Prozess zum Rückruf einer Bürgschaft zu starten.
 * @summary Sende Rückforderung für Bürgschein
 */
 postBuergscheinRueckforderung<TData = void>(vsnr: string,
    bsnr: string, options?: HttpClientBodyOptions): Observable<TData>;
 postBuergscheinRueckforderung<TData = void>(vsnr: string,
    bsnr: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 postBuergscheinRueckforderung<TData = void>(vsnr: string,
    bsnr: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  postBuergscheinRueckforderung<TData = void>(
    vsnr: string,
    bsnr: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}/rueckforderung`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}/rueckforderung`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}/rueckforderung`,
      undefined,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen von Bürgscheinen anhand einer VSNR (Vertragsnummer). Es können nur Bürgscheine für ein bestimmtes Geschäftsjahr (z.B. 2015) abgerufen werden.
 * @summary Rufe die einem Vertrag zugeordneten Bürgscheine ab
 */
 getBuergscheine<TData = BuergscheinListe>(vsnr: string,
    params?: GetBuergscheineParams, options?: HttpClientBodyOptions): Observable<TData>;
 getBuergscheine<TData = BuergscheinListe>(vsnr: string,
    params?: GetBuergscheineParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getBuergscheine<TData = BuergscheinListe>(vsnr: string,
    params?: GetBuergscheineParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getBuergscheine<TData = BuergscheinListe>(
    vsnr: string,
    params?: GetBuergscheineParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheine`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheine`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheine`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen von Details zu einem Bürgschein, identifiziert anhand VSNR und BSNR.
 * @summary Rufe Details zu einem Bürgschein ab
 */
 getBuergschein<TData = Buergschein>(vsnr: string,
    bsnr: string, options?: HttpClientBodyOptions): Observable<TData>;
 getBuergschein<TData = Buergschein>(vsnr: string,
    bsnr: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getBuergschein<TData = Buergschein>(vsnr: string,
    bsnr: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getBuergschein<TData = Buergschein>(
    vsnr: string,
    bsnr: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Dieser Service ermöglicht das Abrufen eines Bürgscheins im PDF-Format, identifiziert anhand VSNR und BSNR.
 * @summary Rufe Bürgschein in Form eines PDFs ab
 */
 getBuergscheinDokument(vsnr: string,
    bsnr: string,
    params?: GetBuergscheinDokumentParams, options?: HttpClientBodyOptions): Observable<Blob>;
 getBuergscheinDokument(vsnr: string,
    bsnr: string,
    params?: GetBuergscheinDokumentParams, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 getBuergscheinDokument(vsnr: string,
    bsnr: string,
    params?: GetBuergscheinDokumentParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  getBuergscheinDokument(
    vsnr: string,
    bsnr: string,
    params?: GetBuergscheinDokumentParams, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `/api/vertraege/${vsnr}/buergscheine/${bsnr}/content`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    ) as Observable<Blob>;
  }
/**
 * Dieser Service ermöglicht das Abrufen aller einem Vertrag zugeordneten Bürgscheinnummern (BSNR) anhand einer VSNR (Vertragsnummer).
 * @summary Rufe die Nummern aller einem Vertrag zugeordneten Bürgscheine ab
 */
 getBuergscheinNummern<TData = BuergscheinNummernResponse>(vsnr: string, options?: HttpClientBodyOptions): Observable<TData>;
 getBuergscheinNummern<TData = BuergscheinNummernResponse>(vsnr: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getBuergscheinNummern<TData = BuergscheinNummernResponse>(vsnr: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getBuergscheinNummern<TData = BuergscheinNummernResponse>(
    vsnr: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheinNummern`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheinNummern`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/api/vertraege/${vsnr}/buergscheinNummern`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

